export class MaskUtils {
  static maskCpf(cpf: string | null | undefined): string {
    if (!cpf) return '';
    const digits = cpf.replace(/[^0-9]/g, '');
    if (digits.length < 11) return cpf;
    return `***.${digits.substring(3, 6)}.${digits.substring(6, 9)}-**`;
  }

  static maskRg(rg: string | null | undefined): string {
    if (!rg || rg.length < 4) return rg || '';
    return `***${rg.substring(Math.floor(rg.length / 2))}**`;
  }

  static maskEmail(email: string | null | undefined): string {
    if (!email || !email.includes('@')) return email || '';
    const [local, domain] = email.split('@');
    if (local.length <= 1) return email;
    return `${local.charAt(0)}***@${domain}`;
  }

  static abbreviateName(name: string | null | undefined): string {
    if (!name || !name.trim()) return name || '';
    const parts = name.trim().split(/\s+/);
    if (parts.length <= 1) return name;
    return `${parts[0]} ${parts[parts.length - 1].charAt(0)}.`;
  }

  static preferSocialName(nome: string | null | undefined, nomeSocial: string | null | undefined): string {
    return nomeSocial && nomeSocial.trim() ? nomeSocial : (nome || '');
  }
}
